const breakpoints = {
  medium: 768,
  large: 1220,
};

function media(breakpoint, callback) {
  mediaQuery({ breakpoint, callback, mobileFirst: true });
}

function mediaDown(breakpoint, callback) {
  mediaQuery({ breakpoint, callback, mobileFirst: false });
}

function getQueryString({ breakpoint, mobileFirst }) {
  return mobileFirst
    ? `(min-width: ${breakpoints[breakpoint]}px)`
    : `(max-width: ${breakpoints[breakpoint] - 1}px)`;
}

function mediaQuery({ breakpoint, callback, mobileFirst = true }) {
  if (!breakpoints[breakpoint]) {
    throw new Error(`Breakpoint ${breakpoint} not found.`);
  }

  const mediaQueryList = window.matchMedia(
    getQueryString({ breakpoint, mobileFirst }),
  );

  if (mediaQueryList.addEventListener) {
    mediaQueryList.addEventListener('change', ({ matches }) => {
      callback({ matches });
    });
  } else if (mediaQueryList.addListener) {
    // for pre-chromium Edge
    mediaQueryList.addListener(({ matches }) => {
      callback({ matches });
    });
  }

  callback({ matches: mediaQueryList.matches, initial: true });
}

function matchMedia(breakpoint, { mobileFirst = true }) {
  return window.matchMedia(getQueryString({ breakpoint, mobileFirst })).matches;
}

export { breakpoints, media, mediaDown, matchMedia };
